export const USER_SESSIONS_TEST_IDS = {
  list: 'user-sessions-list',
  emptyState: 'user-sessions-empty-state',
  errorState: 'user-sessions-error-state',
  row: (sessionId: string) => `user-sessions-row__${sessionId}`,
  currentBadge: 'user-sessions-current-badge',
  revokeButton: (sessionId: string) => `user-sessions-revoke__${sessionId}`,
} as const;
